import React from 'react'
import ShiftCard from '../ShiftCard'
import DailyBreakCard from './DailyBreakCard';

function ResizableDailyBreakCard(props) {
  const [currentShiftInfo, setCurrentShiftInfo] = React.useState(props.shift_info);
  const [appliedTo, setAppliedTo] = React.useState([false, false, false, false, false, false, false]);
  const [dragging, setDragging] = React.useState(null);
  const [dragStart, setDragStart] = React.useState(null);
  const breakField = props.breakField || "break_start";
  const breakLengthField = props.breakLengthField || "break_length";
  const getTotalUnpaidBreakLength = (shiftInfo) =>
    (shiftInfo?.break_length || 0) + (shiftInfo?.break_length_2 || 0);
  const canResize =
    // Dragging a break rewrites the planned shift, so actual mode neither
    // allows it nor offers the resize and move cursors that advertise it.
    !props.showActualTimes &&
    !props.locked_mode &&
    !props.day_in_past &&
    !props.multipleShifts &&
    !currentShiftInfo?.is_copilot_suggestion;

  React.useEffect(() => {
    setCurrentShiftInfo(props.shift_info)
  }, [props.shift_info])

  React.useEffect(() => {
    let appliedToCopy = [false, false, false, false, false, false, false];
    appliedToCopy[props.d] = true;
    setAppliedTo(appliedToCopy);
  }, []);

  const handleMouseDown = (e, type) => {
    e.stopPropagation();
    setDragging(type);
    setDragStart(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      const sensitivity = 0.012;
      const rawShiftAmount = (e.clientX - dragStart) * sensitivity;
      const shiftAmount = rawShiftAmount;

      setCurrentShiftInfo((prevShiftInfo) => {
        const newShiftInfo = { ...prevShiftInfo };
        if (dragging === 'start') {
          newShiftInfo[breakField] += shiftAmount;
          newShiftInfo[breakLengthField] -= shiftAmount;
        } else if (dragging === 'end') {
          newShiftInfo[breakLengthField] += shiftAmount;
        } else if (dragging === 'whole') {
          newShiftInfo[breakField] += shiftAmount;
        }

        newShiftInfo.hours = newShiftInfo.shift_length - getTotalUnpaidBreakLength(newShiftInfo);

        return newShiftInfo;
      });

      setDragStart(e.clientX);
    }
  };

  const handleMouseUp = () => {
    if (dragging) {
      setDragging(null);
      setDragStart(null);

      setCurrentShiftInfo((prevShiftInfo) => {
        const roundToQuarter = (value) => {
          return Math.round(value * 4) / 4;
        };

        const newShiftInfo = { ...prevShiftInfo };
        const minStart = props.minStart ?? newShiftInfo.shift_start;
        const maxEnd = props.maxEnd ?? newShiftInfo.shift_end;

        if (newShiftInfo[breakField] < minStart) {
          newShiftInfo[breakField] = minStart
        }

        if (
          (newShiftInfo[breakField] > maxEnd) ||
          ((newShiftInfo[breakField] + newShiftInfo[breakLengthField]) > maxEnd)
        ) {
          newShiftInfo[breakField] = maxEnd - newShiftInfo[breakLengthField]
        }
        newShiftInfo[breakField] = roundToQuarter(newShiftInfo[breakField]);
        newShiftInfo[breakLengthField] = roundToQuarter(newShiftInfo[breakLengthField]);
        newShiftInfo.hours = newShiftInfo.shift_length - getTotalUnpaidBreakLength(newShiftInfo);

        props.addShift(newShiftInfo, 'edit', appliedTo, true);

        return newShiftInfo;
      });
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, dragStart]);


  return (
    <div
      style={{
        height: 32,
        width: currentShiftInfo?.[breakLengthField] * props.hour_increment + "%",
        marginLeft: (currentShiftInfo?.[breakField] - props.previousEndTime) * props.hour_increment + 15 + "%",
        position: "absolute",
        cursor: 'default',
        zIndex: 10,
      }}
    >
      {canResize && (
        <>
          <div
            onMouseDown={(e) => handleMouseDown(e, 'start')}
            style={{
              position: 'absolute',
              left: -5,
              top: 0,
              bottom: 0,
              width: 10,
              cursor: 'ew-resize',
              zIndex: 9999
            }}
          />
          <div
            onMouseDown={(e) => handleMouseDown(e, 'end')}
            style={{
              position: 'absolute',
              right: -5,
              top: 0,
              bottom: 0,
              width: 10,
              cursor: 'ew-resize',
              zIndex: 9999
            }}
          />
        </>
      )}
      {!props.multipleShifts && (
        canResize ?
        <div
          className="w-full h-full"
          onMouseDown={(e) => handleMouseDown(e, 'whole')}
          style={{
            cursor: 'move'
          }}
        >
          <DailyBreakCard />
        </div> :
        <div
          className="w-full h-full"
        >
          <DailyBreakCard />
        </div>
      )}
    </div>
  )
}

export default ResizableDailyBreakCard
